export default {
  year: '年',
  month: '月',
  day: '日',
  hour: '时',
  minute: '分',
};



// WEBPACK FOOTER //
// ./components/Picker/locale/zh_CN.js